(function () {
    'use strict';

    angular
        .module('skillsApp')
        .directive('examinerSelection', examinerSelection);

    function examinerSelection() {
        return {
            templateUrl: '/app/directives/examiner-selection.tpl.html',
            scope: {
                activity: '=',
                disabled: '=',
                userQuality: '='
            },
            controller: ExaminerSelectionController,
            controllerAs: 'vm',
            bindToController: true
        };
    }

    function ExaminerSelectionController(logger, modalDialogService) {
        var vm = this;
        
        vm.getExaminerName = getExaminerName;
        vm.hasExaminers = hasExaminers;
        vm.isExaminerAlreadySelected = isExaminerAlreadySelected;
        vm.openDialog = openDialog;

        function getExaminerName() {
            return vm.activity.examiner == null ? null : vm.activity.examiner.name;
        }

        function hasExaminers() {
            return vm.activity.examiners && vm.activity.examiners.length > 0;
        }

        function isExaminerAlreadySelected() {
            return vm.activity.examiner != null;
        }

        function openDialog() {
            modalDialogService.openExaminerSelectionDialog(vm.userQuality, vm.activity);
        }
    }

})();